import { OfbizForm, OfbizList } from "@urbannex/ofbiz-forms";
import { ComponentConfig, ConfigOptions, getAppContext, getColumnFieldTitles, getFieldSets, getFields, getIdFieldName, getTarget, getTargets, getTitleDescriptionField } from "@urbannex/view-containers";
import { FORMS } from "./forms";

export const catalogOptions:ConfigOptions = {
    name:"",
    title:"Catalog Component",
    appContext:"catalog",
    menuAndTitleOptions:{
        path:"catalogs",
        headerTitle:"Catalog Information",
        menuItems:[],
        menuTag:"catalogsMenu"
    },
    listForm:new OfbizList({
      listType:"grid",
      fieldFormName:"",
      fieldFormLocation:"local",
      listFormName:"ListCatalog",
      listFormLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
      columnFields:getFields("ListCatalog",FORMS),
      columnFieldTitles:getColumnFieldTitles("ListCatalog",FORMS),
      remoteFormData:{
        formData:{
          formName:"ListCatalog",
          formLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
          listType:"grid",
          viewIndex:1,
        },
        appContext:"catalog",
        parameters:{"noConditionFind":"Y"}
      },
      emptyListMessage:"No catalogs found.  Please create new store."
    }),
    findForm:new OfbizForm(),
    addForm:new OfbizForm({
      formName:"EditProdCatalog",
      formLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
      appContext:"catalog",
      fields:getFields("EditProdCatalog",FORMS),
      fieldSets:getFieldSets("EditProdCatalog",FORMS),
      targets:getTargets("EditProdCatalog",FORMS),
      titleDescriptionField:"catalogName",
      idFieldName:"prodCatalogId"
    }),
    relations:[
        {
            title:"Categories",
            addContainerTitle:"Add Categories To Catalog",
            listContainerTitle:"Categories for ",
            addFormName:"AddProductCategoryToProdCatalog",
            listFormName:"EditProdCatalogCategories",
            keyMap:{fieldName:"prodCatalogId"},
            addForm:new OfbizForm({
                formName:"AddProductCategoryToProdCatalog",
                formLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
                fields:getFields("AddProductCategoryToProdCatalog",FORMS),
                target:getTarget("AddProductCategoryToProdCatalog",FORMS),
                appContext:"catalog",
                local:true,
                entityName:"ProdCatalog"
            }),
            listForm:new OfbizList({
                            listFormLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
                            listFormName:"EditProdCatalogCategories",
                            listType:"grid",
                            columnFields:getFields("EditProdCatalogCategories",FORMS),
                            columnFieldTitles:getColumnFieldTitles("EditProdCatalogCategories",FORMS),
                            emptyListMessage:"No prices found.  Please add existing or create new.",
                            remoteFormData: {
                                formData: {
                                    formName: "EditProdCatalogCategories",
                                    formLocation: "component://kwikstore/widget/ProdCatalogForms.xml",
                                    listType: "grid"
                                },
                                parameters: {}
                            }
                        }),

        },
        {
            title:"Parties",
            addContainerTitle:"Add Parties To ",
            listContainerTitle:"Parties For",
            addFormName:"AddProdCatalogToParty",
            listFormName:"UpdateProdCatalogToParty",
            keyMap:{fieldName:"prodCatalogId"},
            addForm:new OfbizForm({
                formName:"AddProdCatalogToParty",
                formLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
                fields:getFields("AddProdCatalogToParty",FORMS),
                target:getTarget("AddProdCatalogToParty",FORMS),
                appContext:"catalog",
                local:true,
                entityName:"ProdCatalog"
            }),
                listForm:new OfbizList({
                listFormLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
                listFormName:"UpdateProdCatalogToParty",
                listType:"grid",
                columnFields:getFields("UpdateProdCatalogToParty",FORMS),
                columnFieldTitles:getColumnFieldTitles("UpdateProdCatalogToParty",FORMS),
                remoteFormData:{
                  formData: {
                    formName: "UpdateProdCatalogToParty",
                    formLocation: "component://kwikstore/widget/ProdCatalogForms.xml",
                    listType: "grid",
                    entityName: "",
                    viewIndex: 0,
                    viewSize: 20
                  }
                },
                emptyListMessage:"No prices found.  Please add existing or create new."
            }),
        },
        {
            title:"Stores",
            addContainerTitle:"Add Store To ",
            listContainerTitle:"Stores for",
            addFormName:"CreateProductStoreCatalog",
            listFormName:"UpdateProductStoreCatalog",
            keyMap:{fieldName:"prodCatalogId"},
            addForm:new OfbizForm({
                formName:"CreateProductStoreCatalog",
                formLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
                fields:getFields("CreateProductStoreCatalog",FORMS),
                target:getTarget("CreateProductStoreCatalog",FORMS),
                appContext:"catalog",
                local:true,
                entityName:"ProdCatalog"
            }),
            listForm:new OfbizList({
                            listFormLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
                            listFormName:"UpdateProductStoreCatalog",
                            listType:"grid",
                            columnFields:getFields("UpdateProductStoreCatalog",FORMS),
                            columnFieldTitles:getColumnFieldTitles("UpdateProductStoreCatalog",FORMS),
                            emptyListMessage:"No prices found.  Please add existing or create new.",
                            remoteFormData: {
                                formData: {
                                    formName: "UpdateProductStoreCatalog",
                                    formLocation: "component://kwikstore/widget/ProdCatalogForms.xml",
                                    listType: "grid"
                                },
                                parameters: {}
                            }
                        }),
        }
    ],
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Catalogs",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"ListProductStore",
        "data":{
          formData:{
            formName:"ListCatalog",
            formLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
            listType:"grid"
          },
          "endPoint":""
        }
      },
      addFormText:"Create Product Catalog",
      editFormText:"Update Product Catalog"
    },
    settings:[],
    childComponent:new ComponentConfig({
      title:"Catalogs",
      listForm:new OfbizList({
        listType:"grid",
        fieldFormLocation:"local",
        listFormName:"ListCatalog",
        listFormLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
        columnFields:getFields("ListCatalog",FORMS),
        columnFieldTitles:getColumnFieldTitles("ListCatalog",FORMS),
        remoteFormData:{
          formData:{
            formName:"ListCatalog",
            formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            listType:"grid",

          },
          parameters:{"productStoreId":""}
        },
        emptyListMessage:"No catalogs found for this store.  Please add existing or create new."
      }),
      findForm:new OfbizForm(),
      addForm:new OfbizForm({
        local:true,
        formName:"EditProdCatalog",
        formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
        target:getTarget("EditProdCatalog",FORMS),
        targets:getTargets("EditProdCatalog",FORMS),
        fields:getFields("EditProdCatalog",FORMS),
        titleDescriptionField:getTitleDescriptionField("EditProdCatalog",FORMS),
        idFieldName:getIdFieldName("EditProdCatalog",FORMS),
      }),
      actions:["list","find","add","edit"],
      breadCrumbData:{
        displayPrefix:"Catalogs for ",
        label:"",
        level:2,
        selectedValue:{
          "event":"list",
          "type":"ListCatalog",
          "data":{
            formData:{
              formName:"ListCatalog",
              formLocation:"component://kwikstore/widget/StoreForms.xml",
            },
            "endPoint":""
          }
        },
        addFormText:"Create New Catalog",
        editFormText:"Update Catalog"
      },
      relations:[
        {
          title:"Roles",
          addContainerTitle:"Add Catalog Parties",
          listContainerTitle: "Edit Catalog Parties",
          keyMap:{fieldName:"prodCatalogId"},
          addFormName:"AddProdCatalogToParty",
          listFormName:"UpdateProdCatalogToParty",
          listForm:new OfbizList({
            listType:"grid",
            listFormName:"UpdateProdCatalogToParty",
            listFormLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            target:getTarget("UpdateProdCatalogToParty",FORMS),
            columnFields:getFields("UpdateProdCatalogToParty",FORMS),
            fieldFormFields:getFields("AddProdCatalogToParty",FORMS),
            columnFieldTitles:getColumnFieldTitles("UpdateProdCatalogToParty",FORMS),
            appContext:getAppContext("UpdateProdCatalogToParty",FORMS),
            emptyListMessage:"Found no people/organisations for this catalog. Please add exiting are create new.",
            remoteFormData: {
                formData: {
                    formName: "UpdateProdCatalogToParty",
                    formLocation: "component://product/widget/catalog/ProdCatalogForms.xml",
                    listType: "grid"
                },
                parameters: {}
            }
          }),
          addForm:new OfbizForm({
            formName:"AddProdCatalogToParty",
            local:true,
            appContext:getAppContext("AddProdCatalogToParty",FORMS),
            targets:getTargets("AddProdCatalogToParty",FORMS),
            formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            fields:getFields("AddProdCatalogToParty",FORMS)
          })
        },
        {
          title:"Categories",
          addContainerTitle:"Add a Category to this Catalog",
          listContainerTitle:"    Edit Product Catalog Categories",
          keyMap:{fieldName:"prodCatalogId"},
          addFormName:"AddProductCategoryToProdCatalog",
          listFormName:"EditProdCatalogCategories",
          listForm:new OfbizList({
            listType:"grid",
            listFormName:"EditProdCatalogCategories",
            listFormLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            columnFields:getFields("EditProdCatalogCategories",FORMS),
            columnFieldTitles:getColumnFieldTitles("EditProdCatalogCategories",FORMS),
            fieldFormFields:getFields("AddProductCategoryToProdCatalog",FORMS),
            appContext:"product",
            emptyListMessage:"No categories found for this catalog.  Please add existing or create new.",
            remoteFormData: {
              formData: {
                formName: "EditProdCatalogCategories",
                formLocation: "component://product/widget/catalog/ProdCatalogForms.xml",
                listType: "grid"
              },
              parameters: {}
            }
          }),
          addForm:new OfbizForm({
            formName:"AddProductCategoryToProdCatalog",
            local:true,
            appContext:getAppContext("AddProductCategoryToProdCatalog",FORMS),
            targets:getTargets("AddProductCategoryToProdCatalog",FORMS),
            formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            fields:getFields("AddProductCategoryToProdCatalog",FORMS)
          })
        }
      ],
      settings:[],
      
    }),
    outGoingLinks:[
      {
        target:"EditCategory",
        targetType:"",
        targetWindow:"",
        root:"categories",
        segments:[
          {pathElement:"categories",parameter:"prodCatalogId"},
          {pathElement:"category",parameter:"productCategoryId"}
        ],
        parameters:{},
        remoteFormData:{
          formData:{
            formName:"EditCategory",
            formLocation:"component://kwikstore/widget/CategoryForms.xml"
          }
        }
      }
    ]
  }